import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'reactstrap';
import Icon from '../containers/icon';
const Pager = props => {
  const {
    hasNext,
    hasPrevious,
    indexQuery,
    loading,
    pageNext,
    pagePrevious
  } = props;
  const nextPage = () => pageNext(indexQuery);
  const previousPage = () => {
    pagePrevious(indexQuery);
  };
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 4
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    disabled: !hasPrevious || loading,
    onClick: previousPage,
    className: "t-p-previous"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "angle-left"
  }), " Prev")), /*#__PURE__*/React.createElement(Col, {
    sm: 4,
    style: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }
  }, "(Page ", indexQuery.paging.current + 1, ")"), /*#__PURE__*/React.createElement(Col, {
    sm: 4
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    disabled: !hasNext || loading,
    className: "float-md-right t-p-next",
    onClick: nextPage
  }, "Next ", /*#__PURE__*/React.createElement(Icon, {
    glyph: "angle-right"
  }))));
};
Pager.propTypes = {
  hasNext: PropTypes.bool.isRequired,
  hasPrevious: PropTypes.bool.isRequired,
  indexQuery: PropTypes.shape({
    paging: PropTypes.shape({
      current: PropTypes.number.isRequired
    }).isRequired
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  pageNext: PropTypes.func.isRequired,
  pagePrevious: PropTypes.func.isRequired
};
export default Pager;